<template>
  <div class="contentBox">
    <navBox :id="navId"  ref="navBox"></navBox>
    <!-- 列表 -->
    <div class="content">
      <myHeader ref="myHeader"></myHeader>
      <div class="MobelBox" v-if="addType">
        <p class="add-title">{{addType=='add'?'添加':'编辑'}}</p>
        <div class="write-txt" v-if="addType=='add' || addType =='edit'">
          <p class="write-title"><span>*</span>租户名称：</p>
          <div class="write-text">
            <input type="text" v-model="addObj.title">
          </div>
        </div>
        <div class="write-txt" v-if="addType=='add' || addType =='edit'">
          <p class="write-title"><span>*</span>管理人姓名：</p>
          <div class="write-text">
            <input type="text" v-model="addObj.name">
          </div>
        </div>
        <div class="write-txt" v-if="addType=='add' || addType =='edit'">
          <p class="write-title"><span>*</span>管理人手机号：</p>
          <div class="write-text">
            <input type="text" v-model="addObj.mobile"  @input="numCheck(addObj.mobile,11,'addObjMobile')">
          </div>
        </div>

        <div class="write-txt vipDate" v-if="addType=='add' || addType == 'vip'">
          <p class="write-title"><span>*</span>开通会员：</p>
          <div class="write-text">
            <input type="text" v-model="addObj.expiration_time">
            <el-radio-group v-model="vip_date">
              <el-radio label="d">天</el-radio>
              <el-radio label="m">月</el-radio>
              <el-radio label="y">年</el-radio>
            </el-radio-group>
          </div>
        </div>

        <div class="write-txt aiData" v-if="addType=='add' || addType=='num'">
          <p class="write-title"><span>*</span>AI标签免费识别次数：</p>
          <div class="write-text">
            <input type="text" v-model="addObj.ai_free_num">
            <span>次</span>
          </div>
        </div>

        <div class="write-txt statusData" v-if="addType=='add'">
          <p class="write-title"><span>*</span>状态：</p>
          <div class="write-text">
            <el-radio-group v-model="addObj.status">
              <el-radio label="1">开启</el-radio>
              <el-radio label="0">停用</el-radio>
            </el-radio-group>
          </div>
        </div>

        <div class="write-btnBox">
          <button class="btn btn-save" @click="saveSub">确定</button>
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>
      <div class="organiza-txt" v-else>
        <div class="organiza-title clear">
          <div class="organiza-left" @click="addSub">
            <img src="~@/assets/images/icon-add.png" alt="">
            <p>添加租户</p>
          </div>
          <div class="searchBox clear">
            <div class="search-item">
              <p>租户名称：</p>
              <input type="text" placeholder="请输入要搜索的租户名称" v-model="obj.title">
            </div>
            <div class="search-item">
              <p>手机号：</p>
              <input type="text" placeholder="请输入要搜索的手机号" v-model="obj.mobile"  @input="numCheck(account,11,'mobile')">
            </div>
            <div class="search-item">
              <p>状态：</p>
              <el-select v-model="obj.status" placeholder="请选择">
                <el-option
                  v-for="item in statusList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="search-btnBox">
              <button class="btn btn-search" @click="searchSub">搜索</button>
              <button class="btn btn-reset" @click="resetSub">重置</button>
            </div>
          </div>
        </div>
        <div class="organiza-list">
          <div class="list-title">租户列表</div>
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="item.key">{{item.key}}</p>
              <p :title="item.oid">{{item.oid}}</p>
              <p :title="item.title">{{item.title}}</p>
              <p :title="item.name">{{item.name}}</p>
              <p :title="item.mobile">{{item.mobile}}</p>
              <p :title="item.ai_free_num">{{item.ai_free_num}}</p>
              <p>
                <el-switch
                  @change="switchChange(item)"
                  v-model="item.status"
                  active-color="#457AFF"
                  inactive-color="#CBCBCB">
                </el-switch>
              </p>
              <p :title="item.expiration_time">{{item.expiration_time}}</p>
              <p>
                <button class="btn btn-build" title="编辑" @click="buildShow(item)">编辑</button>
                <button class="btn btn-vip" title="增加会员" @click="vipShow(item)">增加会员</button>
                <button class="btn btn-label" title="增加标签" @click="numShow(item)">增加标签免费次数</button>
              </p>
            </div>
          </div>
          
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getOrgList , addOrg ,getOrgDetail ,updateOrgStatus ,updateOrg ,addOrgVip} from "@/assets/js/api";
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
export default {
  name: "index",
  data() {
    return {
      navId:'8',
      titleList:[
        {id:1,title:'序号'},
        {id:2,title:'ID'},
        {id:3,title:'租户名称'},
        {id:4,title:'管理人'},
        {id:5,title:'管理人手机号'},
        {id:6,title:'标签免费次数'},
        {id:7,title:'状态'},
        {id:8,title:'到期时间'},
        {id:9,title:'操作'},
      ],
      dataList:[],
      addType:'',
      token:'',
      obj:{
        page:1,
        rows:10,
        status:9
      },
      addObj:{
        title:'',
        status:'1',
        mobile:'',
        name:'',
        expiration_time:'',
        ai_free_num:''
      },
      totalPage:0,
      statusList:[
        {id:0,title:'未开启',value:0},
        {id:1,title:'已开启',value:1},
        {id:9,title:'全部',value:9},
      ],
      vip_date:'d'
    };
  },
  components: {
    navBox,
    myHeader
  },
  mounted(){
    var userData = JSON.parse(localStorage.getItem('userData'));
    this.token = userData.adminToken;
    this.url = this.$refs.navBox.url;
    this.getList();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },

    async getList(){
      var that = this;
      try {
        const response = await getOrgList(this.obj,this.token);
        if(response.code == 200){
          response.data.list.forEach(function(item,index){
            if(item.status==0){
              item.status=false
            } else {
              item.status=true
            }
          })
          that.dataList = response.data.list;
          that.totalPage = response.data.total_page;        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    addSub(){
      var that = this;
      this.addType = 'add';
      this.addObj = {
        title:'',
        status:'1',
        mobile:'',
        name:'',
        expiration_time:'',
        ai_free_num:''
      }
    },

    async buildShow(e){
      var that = this;
      try {
        const response = await getOrgDetail({oid:e.oid},this.token);
        if(response.code == 200){
          that.addType = 'edit';   
          that.addObj = {
            mobile: response.data.mobile,
            name: response.data.name,
            oid: response.data.oid,
            title: response.data.title,
          }    
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
      
    },

    vipShow(e){
      this.addObj = {
        oid:e.oid,
        expiration_time:'',
      };
      this.addType = 'vip';
    },

    numShow(e){
      this.addObj = {
        oid:e.oid,
        ai_free_num:'',
      };
      this.addType = 'num';
    },

    ModelHide(type){
      var that = this;
      if(type == 'remove'){
        that.removeType = false;
        taht.removeID = '';
      }
    },

    async saveSub(){
      var that = this;
      if(this.addType == 'edit'){
        this.buildSub();
        return false;
      }
      if(this.addType == 'vip'){
        this.vipSub();
        return false;
      }
      if(this.addType == 'num'){
        this.numSub();
        return false;
      }
      if(this.addObj.title == ''){
        that.$message('请输入标题！');
        return false;
      }
      if(this.addObj.mobile == ''){
        that.$message('请输入手机号！');
        return false;
      }
      if(this.vip_date == ''){
        that.$message('请选择到期时间！');
        return false;
      }
      if(this.addObj.ai_free_num == ''){
        that.$message('请输入次数！');
        return false;
      }
      this.addObj.expiration_time = this.addObj.expiration_time  + this.vip_date;
      try {
        const response = await addOrg(this.addObj,this.token);
        if(response.code == 200){
          that.$message('成功');
          that.closeSub();
          that.getList();        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async buildSub(){
      var that =this;
      try {
        const response = await updateOrg(this.addObj,this.token);
        if(response.code == 200){
          that.$message('成功');
          that.closeSub();
          that.getList();        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async vipSub(){
      var that =this;
      this.addObj.expiration_time = this.addObj.expiration_time + this.vip_date;
      try {
        const response = await addOrgVip(this.addObj,this.token);
        if(response.code == 200){
          that.$message('成功');
          that.closeSub();
          that.getList();        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async numSub(e){
      var that = this;
      try {
        const response = await addOrgVip(that.addObj,this.token);
        if(response.code == 200){
          that.$message('成功');
          that.closeSub();
          that.getList();        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
      
    },

    closeSub(){
      this.addType = '';
      this.addObj = {
        title:'',
        status:'1',
        mobile:'',
        name:'',
        expiration_time:'',
        ai_free_num:''
      }
    },

    async switchChange(e){
      var that = this;
      var obj = {
        oid:e.oid,
        status:e.status==false?0:1,
      };
      try {
        const response = await updateOrgStatus(obj,this.token);
        if(response.code == 200){
          that.$message('发布状态修改成功！');
          that.getList();      
        } else {
          that.$message(response.msg);
          e.status = !e.status;
        }
      } catch (error) {
        that.$message(error);
        e.status = !e.status;
      }
    },

    searchSub(){
      this.obj.page = 1;
      this.dataList = [];
      this.getList();
    },

    resetSub(){
      this.obj={
        page:1,
        rows:10,
        status:9
      };
      this.addObj={};
      this.totalPage = 0;
      this.dataList = [];
      this.getList();
    },

    numCheck(e,i,type){
      var that = this;
      var num = e;
      num = num.length;
      if(num > i){
          if(type == 'mobile'){
              e = e.slice(0,11);
              that.account = e;
          } else if(type == 'addObjMobile'){
            e = e.slice(0,11);
            that.addObj.mobile = e;
          } else {
              that.code = JSON.stringify(e).slice(0,4)
          }
      }
    },
  }

  
};
</script>
<style scoped>
  .dataList .listItem p, 
  .organiza-list p{
    width: calc( 100% / 10 );
  }

  .btn-remove,
  .btn-revise{
    background-image: url(~@/assets/images/btn-revise.png);
    width: 22px;
    height: 22px;
    background-size: 22px 22px;
    display: inline-block;
    vertical-align: top;
  }

  .btn-remove{
    background-image: url(~@/assets/images/btn-remove.png);
    margin-left: 10px;
  }

  .add-title,
  .list-title{
    color: #333333;
    font-size: 24px;
    display: block;
    margin-bottom: 20px;
    position: relative;
    padding-left: 20px;
  }

  .add-title::before,
  .list-title::before{
    content: '';
    width: 5px;
    height: 22px;
    background-color: #6098F2;
    position: absolute;
    top: 50%;
    transform: translate(0,-50%);
    left: 5px;
  }

  .MobelBox{
    padding: 40px;
    box-sizing: border-box;
    width: 100%;
  }

  .MobelBox .write-txt{
    display: block;
    width: 100%;
    margin-bottom: 20px;
  }

  .MobelBox .write-text{
    display: inline-block;
    vertical-align: top;
    width: 80%;
    margin-left: 20px;
  }

  .MobelBox .write-text span{
    font-size: 14px;
    color: #E2231A;
    margin-top: 10px;
    display: block;
  }

  .MobelBox input,
  .MobelBox textarea{
    width: 80%;
    height: 334px;
    background-color: #FFFFFF;
    border-radius: 6px;
    display: block;
    padding: 20px;
    box-sizing: border-box;
    border: solid 1px #333333;
    font-size: 16px;
  }

  .MobelBox input{
    height: 50px;
    line-height: 50px;
    width: 500px;
  }

  .MobelBox>>> .el-input{
    font-size: 16px;
  }

  .msgBox .contv{
    padding: 40px 73px;
    border-radius: 32px;
  }

.msgBox .title {
  text-align: center;
  margin-bottom: 50px;
}

.btn-import{
  display: inline-block;
  vertical-align: top;
}

.btn-ai{
  background-color: #6098F2;
  border-radius: 6px;
  color: #fff;
  font-size: 18px;
  color: #fff;
  box-sizing: border-box;
  padding: 0px 20px;
  height: 50px;
  line-height: 50px;
  display: inline-block;
  margin-left: 20px;
}

.ai-msg{
  height: 50px;
  line-height: 50px;
  color: #777777;
  font-size: 20px;
  display: inline-block;
  margin-left: 20px;
}

.MobelBox .write-ai .write-text{
  width: auto;
}


.topicList{
  display: block;
}

.topic-title{
  font-size: 20px;
  color: #333333;
  display: inline-block;
  vertical-align: top;
  height: 36px;
  line-height: 36px;
  margin-bottom: 20px;
}

.topic-title .btn-remove{
  font-size: 20px;
  color: #fff;
  display: inline-block;
  vertical-align: top;
  height: 36px;
  line-height: 36px;
  background-color: #6098F2;
  background-image: none;
  width: 110px;
  border-radius: 6px;
}

.aiData input,
.vipDate input{
  display: inline-block;
  width: 100px;
}

.aiData .write-text span{
  display: inline-block;
  font-size: 20px;
  margin-left: 10px;
  color: #333;
}

.vipDate .el-radio-group{
  display: inline-block;
  margin-left: 20px;
}

.vipDate>>> .el-radio__label{
  font-size: 20px;
}

.vipDate>>> .el-radio__inner{
  width: 20px;
  height: 20px;
}

.vipDate>>> .el-radio__inner::after{
  width: 12px;
  height: 12px;
}

.statusData>>> .el-radio__inner{
  width: 20px;
  height: 20px;
}

.statusData>>> .el-radio__inner::after{
  width: 10px;
  height: 10px;
}

.statusData>>> .el-radio__label{
  font-size: 20px;
  line-height: 50px;
}

.organiza-txt>>>.el-upload{
  width: 100%;
  display: block;
}

.organiza-txt>>>.el-button--small span{
  width: 100%;
  text-align: center;
  display: block;
}

.organiza-txt>>>.el-button--primary{
  background-color: transparent;
  border: none;
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/user/index.vue